import url from "@/api/url.js"
// 请求时不需要加载全局loading的接口
const unloadList = [
  url.getClassroomList, // 课室列表
  url.getCourseList, // 科目列表
  url.getgradeList, // 年级列表
  url.selectTeacherListByAdminPC, // 教师列表
  url.selectStudentLeaveListByFiltrate, // 请假列表
  url.selectLeaveRecordType, // 请假类型
  url.getNewsList, // 公告列表
  url.selectStudentListPC, // 学生列表
  url.selectTeacherHomeworkList, // 作业列表
  url.selectClassScorePC, // 考试信息列表 教师
  url.selectExamInfoByAdminPC, // 考试信息列表 管理员
  url.selectTeacherHomeworkList, // 作业教师列表
  url.getStudentInfo, // 免打扰学生列表
]

export default unloadList